<script lang="ts">
import { defineComponent, PropType, VNode } from 'vue';
import { sortItems, SortOptions } from '@/sort/sortItems';

export default defineComponent({
  name: 'SortManager',

  props: {
    items: {
      required: true,
      validator: (prop) => prop === null || Array.isArray(prop),
      type: Array as PropType<Array<{ [key: string]: any }>>,
    },

    sorting: {
      type: Array as unknown as PropType<SortOptions>,
      required: true,
    },
  },

  computed: {
    sortedItems(): Array<{ [key: string]: any }> {
      return this.items ? sortItems(this.sorting, this.items) : [];
    },
  },

  render(): VNode {
    return this.$slots.default({
      items: this.sortedItems,
    })[0];
  },
});
</script>
